import compose from 'recompose/compose';
import { withRouter } from 'react-router-dom';
import DynamicLoginPartial from './DynamicLoginPartial';
import formatPrismicData from '../../hocs/formatPrismicData';
import withMediaQueries from '../../hocs/withMediaQueries';
import withCountry from '../../hocs/withCountry';
import withProps from 'recompose/withProps';

const enhance = compose(
  formatPrismicData,
  withCountry,
  withRouter,
  withMediaQueries,
  withProps(props => {
    const pathname = props.history.location.pathname;
    const search = props.history.location.search;
    return {
      returnToPath: `${pathname}${search}`,
      isMobile: props.media.mobile,
    };
  })
);

export default enhance(DynamicLoginPartial);



// WEBPACK FOOTER //
// ./src/client/js/view/components/DynamicLoginPartial/index.js